import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

export const ChatSearchBar = ({ setInput, addMode, setAddMode }) => {
  return (
    <div className="search">
        <div className="searchBar">
            <SearchIcon />

            <input 
                type="text"
                placeholder="Search..."
                onChange={(e) => setInput(e.target.value)}
            />
        </div>

        <div className="add" onClick={() => setAddMode(prev => !prev)}>
            {addMode ? <RemoveIcon /> : <AddIcon />}
        </div>
    </div>
  );
};